import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { Container } from "./container";

import TextureImage from "../images/texture-over-dark.png";
import LukeGambleLogo from "../images/luke-gamble-logo-bottom.png";
import FooterSocialImage from "../images/footer-social.jpg";

const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  background: #007d9e url(${TextureImage});
  color: #fff;
`;

const Bar = styled.div`
  min-height: 78px;
  display: flex;
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const MenuLinksContainer = styled.div`
  height: 100%;
  text-align: right;
  position: relative;
  padding: 13px 0;
`;

const MenuLink = styled(Link)`
  margin: 13px;
  line-height: 26px;
  font-weight: 700;
  display: inline-block;
  text-decoration: none;
  color: #fff;
`;

const CopyrightBar = styled(Bar)`
  background-color: rgba(51, 51, 51, 0.35);
`;

const Logo = styled.img`
  height: auto;
  width: 190px;
  flex-shrink: 0;
`;

const SocialBar = styled.aside`
  background-color: #126176;
  background-image: url(${FooterSocialImage});
  background-position: center center;
  min-height: 255px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SocialContent = styled.div`
  width: 320px;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 26px 26px 13px 26px;
`;

const SocialIntro = styled.p`
  font-family: "museo-sans-condensed", "HelveticaNeue-CondensedBold", Impact,
    sans-serif;
  font-weight: 600;
  color: #1c829d;
  font-size: 1.3125em;
  line-height: 1.2381em;
  margin: 0;
  margin-bottom: 0.61905em;
`;

const SocialText = styled.p`
  text-align: center;
  color: rgb(51, 51, 51);
  line-height: 26px;
  margin: 0;
  margin-bottom: 8.66667px;
`;

const SocialLinksContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  > :not(:last-child) {
    margin-right: 5px;
  }
`;

const SocialLink = styled.a`
  border: 0 !important;
  bottom: 8px;
  color: #1c829d;
  display: block;
  font-family: "icomoon";
  font-size: 33.8px;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  height: 43.8px;
  left: 0;
  line-height: 1;
  text-decoration: none;
  text-transform: none;
  width: 34.8px;
`;

const FacebookLink = styled(SocialLink)`
  :before {
    content: "\\e914";
  }
`;
const TwitterLink = styled(SocialLink)`
  :before {
    content: "\\e931";
  }
`;
const YoutubeLink = styled(SocialLink)`
  :before {
    content: "\\e935";
  }
`;
const InstagramLink = styled(SocialLink)`
  :before {
    content: "\\e91c";
  }
`;
const PinterestLink = styled(SocialLink)`
  :before {
    content: "\\e93e";
  }
`;

export const Footer = () => {
  return (
    <StyledFooter>
      <SocialBar>
        <SocialContent>
          <SocialIntro>Follow Luke's social networks</SocialIntro>
          <SocialText>
            Keep up to date with all Luke's latest news and updates.
          </SocialText>
          <SocialLinksContainer>
            <FacebookLink
              href="https://www.facebook.com/LukeGambleVet"
              rel="noopener noreferrer"
              target="_blank"
            />
            <TwitterLink
              href="https://twitter.com/lukegamble"
              rel="noopener noreferrer"
              target="_blank"
            />
            <YoutubeLink
              href="https://www.youtube.com/channel/UCRNGl-71SJiwSs6zbw-7beQ"
              rel="noopener noreferrer"
              target="_blank"
            />
            <InstagramLink
              href="https://www.instagram.com/lukegamblevet/"
              rel="noopener noreferrer"
              target="_blank"
            />
            <PinterestLink
              href="https://uk.pinterest.com/wvscharity/luke-gamble/"
              rel="noopener noreferrer"
              target="_blank"
            />
          </SocialLinksContainer>
        </SocialContent>
      </SocialBar>
      <Bar>
        <Container>
          <MenuContainer>
            <Logo src={LukeGambleLogo} />
            <MenuLinksContainer>
              <MenuLink to="/">Home</MenuLink>
              <MenuLink to="/latest">Latest</MenuLink>
              <MenuLink to="/writing">Writing</MenuLink>
              <MenuLink to="/charities">Charities</MenuLink>
              <MenuLink to="/show-reel">Show Reel</MenuLink>
              <MenuLink to="/bio">Bio</MenuLink>
              <MenuLink to="/contact">Contact</MenuLink>
            </MenuLinksContainer>
          </MenuContainer>
        </Container>
      </Bar>
      <CopyrightBar>
        <Container>&copy; Luke Gamble {new Date().getFullYear()}</Container>
      </CopyrightBar>
    </StyledFooter>
  );
};
